import { Gallery, Heading, Layout } from "../../../components/utils";

import doigettokeepthisbody from "../../../img/digital/do i get to keep this body.jpg";
import thelastride from "../../../img/digital/the last ride.jpg";
import ihopeiseeyouagain from "../../../img/digital/i hope i see you again.jpg";
import aswefade1 from "../../../img/digital/as we fade i.jpg";
import aswefade2 from "../../../img/digital/as we fade ii.jpg";
import aswefade3 from "../../../img/digital/as we fade iii.jpg";
import fall from "../../../img/digital/fall.jpg";
import famouscollage from "../../../img/digital/famouscollage.jpg";
import moon from "../../../img/digital/moon.gif";
import prescriptions from "../../../img/digital/prescriptions.png";

export const Digital = () => {
  return (
    <>
      <Layout grid={8}>
        <Heading
          period={6}
          start={0}
          gridStart={5}
          gridEnd={8}
          tag="h2"
          text="digital work"
        />
        <Gallery
          gridStart={1}
          gridEnd={9}
          height={500}
          grid={2}
          gutter={16}
          data={[
            { image: doigettokeepthisbody, caption: "do i get to keep this body" },
            { image: thelastride, caption: "the last ride" },
            { image: ihopeiseeyouagain, caption: "i hope i see you again" },
            { image: aswefade1, caption: "as we fade I" },
            { image: aswefade2, caption: "as we fade II" },
            { image: aswefade3, caption: "as we fade III" },
            { image: fall, caption: "first day of fall" },
            { image: famouscollage, caption: "Untitled" },
            { image: moon, caption: "moon" },
            { image: prescriptions, caption: "Prescriptions" },
          ]}
        />
      </Layout>
    </>
  );
};
